export const inbox = {
  titles: {
    inbox: "Inbox",
    unifiedInbox: "Your inbox, unified",
  },
  subtitles: {
    manageMessages: "Manage messages from your booking channels",
    unifiedDesc:
      "Here you’ll see all conversations with your guests, regardless of whether they write from Airbnb, Booking, or another channel.",
    subscribeHint:
      "Subscribe to activate your inbox and simplify your communications.",
    planOnly:
      "This module is only available for {plans} plans.",
  },
  states: {
    notInstalledTitle: "Messages module not installed",
    notInstalledDesc:
      "Install the messaging module to connect with your booking channels.",
    noChannelsTitle: "No channels connected",
    noChannelsDesc:
      "To use the messaging module, at least one channel must be connected (Booking.com, Airbnb).",
    noAccessTitle: "You don’t have access to the messages module",
  },
  actions: {
    installModule: "Install messages module",
    configureChannel: "Configure channel",
  },
  toasts: {
    connectChannelRequiredTitle: "Connection required",
    connectChannelRequiredBody:
      "Connect at least one booking channel to install the messages module.",
  },
  errors: {
    notFoundPropertyOrUser: "Property or user not found.",
    channelConnectGeneric:
      "Error connecting to the channel. Please try again.",
    generateTokenError: "Error generating token",
  },
};
